
import { mapState } from 'vuex'
export default {
    data() {
        return {
            tab: 0,
        }
    },
    computed: {
        ...mapState({
            itemTiers: (state) => state.activities['exchange-reward'].itemTiers,
            rewards: (state) => state.activities['exchange-reward'].rewards,
            vipTiers: (state) => state.activities['vip-system'].vipTiers,
            rewardsLoading: (state) =>
                state.activities['exchange-reward'].rewardsLoading,
            getAllTiersLoading: (state) =>
                state.activities['exchange-reward'].getAllTiersLoading,
            defaultCurrency: (state) => state.settings.defaultCurrency,
        }),
        rewardsById() {
            return (v) => {
                return this.rewards[`${v}:2`] || []
            }
        },
        itemTiersLoading() {
            return this.getAllTiersLoading[1]
        },
    },
    watch: {
        itemTiers(value) {
            if (value.length) {
                this.getTierRewardsByTierIndex(0)
            }
        },
    },
    mounted() {
        if (this.itemTiers?.length) {
            // Get rewards
            this.getTierRewardsByTierIndex(0)
        }
        // Check notification and fetch rewards items
        this.unsubscribeAction = this.$store.subscribeAction(
            (mutation, state) => {
                if (
                    mutation.type === 'sockets/rejectExchangeReward' ||
                    mutation.type === 'sockets/approvedExchangeReward'
                ) {
                    this.refetch()
                }
            }
        )
    },
    beforeDestroy() {
        if (this.unsubscribeAction) {
            this.unsubscribeAction()
        }
    },
    methods: {
        onTabChange(value) {
            this.getTierRewardsByTierIndex(value)
        },
        getTierRewardsByTierIndex(index) {
            const tierIndexId = this.itemTiers[index].id
            if (!tierIndexId) return

            // If the rewards are already loaded, do not fetch again
            if (this.rewards[`${tierIndexId}:2`]) return

            this.$store.dispatch('activities/exchange-reward/getTierRewards', {
                reward_type: 2,
                tier_id: tierIndexId,
                currency: this.defaultCurrency,
            })
        },
        refetch() {
            const tierIndexId = this.itemTiers[this.tab].id
            this.$store.dispatch('activities/exchange-reward/getTierRewards', {
                reward_type: 2,
                tier_id: tierIndexId,
                currency: this.defaultCurrency,
            })
        },
    },
}
